import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import {
	AsyncJSMOperationsHorizontalNav,
	LazyJSMOperationsHorizontalNav,
} from '@jira/navigation-apps__horizontal-nav-jsm-operations/src/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { changeCalendarViewSettingsResource } from '@jira/router-resources__jsm-change-management-change-calendar/src/changeCalendarViewSettingsResource.tsx';
import { changeCalendarFilterSettingsResource } from '@jira/router-resources__jsm-change-management-change-calendar/src/changeCalendarFilterSettingsResource.tsx';
import { workspaceResource } from '@jira/servicedesk__insight-common-services-workspace-context/src/workspaceResource.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { servicedeskChangeCalendarRoute } from '@jira/router-routes__servicedesk-change-calendar-routes/src/servicedeskChangeCalendarRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ChangeCalendar, { LazyChangeCalendar } from './ui/calendar/index.tsx';

export const servicedeskChangeCalendarRouteEntry: Route = createEntry(
	servicedeskChangeCalendarRoute,
	() => ({
		group: 'servicedesk',
		ufoName: 'service-management.change-calendar',
		// eslint-disable-next-line no-restricted-syntax
		component: ChangeCalendar,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncJSMOperationsHorizontalNav,
		},

		layout: serviceProjectLayout,

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
			changeCalendarViewSettingsResource,
			changeCalendarFilterSettingsResource,
			workspaceResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyChangeCalendar, LazyJSMOperationsHorizontalNav],

		meta: {
			reporting: {
				id: 'changeCalendar',
				packageName: toPackageName(APP_NAMES.CHANGE_CALENDAR),
				teamName: 'jenga',
			},
		},

		supportsPreviewPanel: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
